export const MS3_OUTCODES = [
  'DN15',
  'DN16',
  'DN17',
  'DN31',
  'DN32',
  'DN33',
  'DN34',
  'DN35',
  'DN37',
  'DN40',
  'DN6',
  'HU10',
  'HU13',
  'HU2',
  'HU3',
  'HU4',
  'HU5',
  'HU6',
  'HU8',
  'HU9',
  'S63',
  'S64'
]

export const CITY_FIBRE_OUTCODES_CV = ['CV1', 'CV2', 'CV3', 'CV4', 'CV5', 'CV6']

export const CITY_FIBRE_OUTCODES_MK = [
  'MK1',
  'MK2',
  'MK3',
  'MK4',
  'MK5',
  'MK6',
  'MK7',
  'MK8',
  'MK9',
  'MK10',
  'MK11',
  'MK12',
  'MK13',
  'MK14',
  'MK15',
  'MK16',
  'MK17'
]

export const CITY_FIBRE_OUTCODES = [...CITY_FIBRE_OUTCODES_CV, ...CITY_FIBRE_OUTCODES_MK]

const getOutcode = (postcode) => postcode?.split(' ')[0]

export const isProviderOutcode = (postcode, validOutcodes = []) => {
  return validOutcodes.includes(getOutcode(postcode))
}

export const isTrustpilotScoreAbove4 = (trustScore) => trustScore >= 4
